<template>
  <b-card>
    <BulkOperationsLista />
  </b-card>
</template>
<script>
export default {
  name: 'BulkRecordOperations',
  components: {
    BulkOperationsLista: () => import('@/app-modulo/comuns/bulk-operations/shared/BulkOperationsLista.vue'),
  },
}
</script>

<style scoped lang="scss">

</style>
